




































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { getCost, isCryptoSystem } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import ChoosePaymentSystem from "@/components/ChoosePaymentSystem";
import FormatMoney from "@/components/FormatMoney";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import UserSubscribeModal from "@/components/UserSubscribeModal";

@Component({
  name: "UnlockFeedView",
  components: { UserSubscribeModal, PageTitle, BaseButton, ModalView, BaseConfirm, FormatMoney, ChoosePaymentSystem },
})
export default class UnlockFeedView extends Vue {
  @Prop({ required: true })
  public selectedFeed!: ContentFeed;

  @Prop({ type: Array, required: true })
  public readonly paymentPackages!: PaymentPackage[];

  @Prop({ type: Boolean, required: true })
  public readonly purchaseProcessing!: boolean;

  @Prop({ required: true, type: Array })
  public readonly paymentSystemsPublic!: PaymentSystemPublic[];

  public showChooseSystem = false;

  public get hasCrypto() {
    return this.paymentSystemsPublic.some(p => isCryptoSystem(p.type));
  }

  public get purchaseSubjectType() {
    return ContentPriceSubjectTypeEnum.CONTENT_SET;
  }

  public get isOnlyPrice() {
    return this.selectedFeed.subscriptionLevelId === "0" && this.selectedFeed.pricePackageId !== "0";
  }

  public get oneTimeCost() {
    if (this.selectedFeed.pricePackageId === "0") return 0;
    const paymentPackage = this.paymentPackages.find(item => item.id === this.selectedFeed.pricePackageId);
    if (!paymentPackage) return 0;
    return getCost(paymentPackage);
  }

  public handleSubscribePurchaseClick(subscribeModalProcessing: boolean) {
    if (!this.purchaseProcessing && !subscribeModalProcessing) {
      if (this.hasCrypto) {
        this.showChooseSystem = true;
      } else {
        this.$emit("purchase", this.selectedFeed);
      }
    }
  }

  public onChooseSystem(paymentSystemType: string) {
    if (!isCryptoSystem(paymentSystemType) && !this.purchaseProcessing) {
      this.$emit("purchase", this.selectedFeed);
    }
  }
}
